import { IAppContext } from './appContext';

export enum AppActionTypes {
	ADD_APP_ERROR = 'ADD_APP_ERROR',
	REMOVE_APP_ERROR = 'REMOVE_APP_ERROR',
	SHOW_LOADER = 'SHOW_LOADER',
	HIDE_LOADER = 'HIDE_LOADER',
	SET_UPLOAD_PROGRESS = 'SET_UPLOAD_PROGRESS',
	SET_ENTITY_NAME_FOR_HEADER = 'SET_ENTITY_NAME_FOR_HEADER',
	LOG_IN = 'LOG_IN',
	SET_NOTIFICATIONS_CONNECTION = 'SET_NOTIFICATIONS_CONNECTION',
	SET_PATHNAMES_HISTORY = 'SET_PATHNAMES_HISTORY',
	SET_FEATURE_FLAGS = 'SET_FEATURE_FLAGS',
}

interface IAddAppError {
	type: AppActionTypes.ADD_APP_ERROR;
	payload: {
		error: IAppContext['appErrors'][0];
	};
}

interface IRemoveAppError {
	type: AppActionTypes.REMOVE_APP_ERROR;
	payload: {
		appErrors: IAppContext['appErrors'];
	};
}

interface IShowLoaderAction {
	type: AppActionTypes.SHOW_LOADER;
}

interface IHideLoaderAction {
	type: AppActionTypes.HIDE_LOADER;
}

interface ISetUploadProgress {
	type: AppActionTypes.SET_UPLOAD_PROGRESS;
	payload: {
		uploadProgress: IAppContext['uploadProgress'];
	};
}

interface ISetEntityNameForHeader {
	type: AppActionTypes.SET_ENTITY_NAME_FOR_HEADER;
	payload: {
		entityNameForHeader: IAppContext['entityNameForHeader'];
	};
}

interface ILogInAction {
	type: AppActionTypes.LOG_IN;
	payload: {
		loggedUser: IAppContext['loggedUser'];
	};
}

interface ISetNotificationsConnection {
	type: AppActionTypes.SET_NOTIFICATIONS_CONNECTION;
	payload: {
		notificationsConnection: IAppContext['notificationsConnection'];
	};
}

interface ISetPathnamesHistory {
	type: AppActionTypes.SET_PATHNAMES_HISTORY;
	payload: {
		pathnamesHistory: IAppContext['pathnamesHistory'];
	};
}

interface ISetFeatureFlags {
	type: AppActionTypes.SET_FEATURE_FLAGS;
	payload: {
		featureFlags: IAppContext['featureFlags'];
	};
}

export type TAppAction =
	| IAddAppError
	| IRemoveAppError
	| IShowLoaderAction
	| IHideLoaderAction
	| ISetUploadProgress
	| ISetEntityNameForHeader
	| ILogInAction
	| ISetNotificationsConnection
	| ISetPathnamesHistory
	| ISetFeatureFlags;
